import { render, staticRenderFns } from "./Cogs.vue?vue&type=template&id=2e7e1d0d"
import script from "./Cogs.vue?vue&type=script&lang=js"
export * from "./Cogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports